import AttendanceTimeRecordsList from "./attendance-time-records-list";


const AttendanceLists = {
    TimeRecords: AttendanceTimeRecordsList
};

export {
    AttendanceTimeRecordsList
};

export default AttendanceLists;
